import { Column } from "../types";
import React from "react";

export const getColumnStyle = (c: Column<any>): React.CSSProperties => {
  const w = (c as any).width ?? c.minWidth ?? 160;
  return {
    width: w,
    minWidth: w,
    maxWidth: w,
    boxSizing: "border-box",
  };
};
